import { memo } from "react";
import { usePriceSubscription } from "../../hooks/usePriceSubscription";
import { useTheme } from "../../theme/ThemeContext";

const PriceDisplay = memo(({ symbol, type = "both", digits = 5, style }) => {
    const price = usePriceSubscription(symbol);
    const theme = useTheme();

    const formatPrice = (value) => {
        return typeof value === "number" ? value.toFixed(digits) : "--";
    };

    if (!price) {
        return (
            <div style={{ display: "flex", alignItems: "center", ...style }}>
                <span
                    style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: theme.textS,
                        fontFamily: theme.mono
                    }}
                >
                    --
                </span>
            </div>
        );
    }

    if (type === "bid") {
        return (
            <span
                style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.neg,
                    fontFamily: theme.mono,
                    ...style
                }}
            >
                {formatPrice(price.bid)}
            </span>
        );
    }

    if (type === "ask") {
        return (
            <span
                style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.pos,
                    fontFamily: theme.mono,
                    ...style
                }}
            >
                {formatPrice(price.ask)}
            </span>
        );
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                fontFamily: theme.mono,
                ...style
            }}
        >
            <span
                style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.neg
                }}
            >
                {formatPrice(price.bid)}
            </span>

            <span
                style={{
                    fontSize: 12,
                    margin: "0 4px",
                    color: theme.textS
                }}
            >
                /
            </span>

            <span
                style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.pos
                }}
            >
                {formatPrice(price.ask)}
            </span>
        </div>
    );
});

PriceDisplay.displayName = "PriceDisplay";

export default PriceDisplay;